export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Practice_Reading.mp3";